import { CustomButtonProps } from '@/components/Button/Button';

export const buttonLifeTimeExclusionProps: CustomButtonProps = {
  variant: 'primary',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
};
